import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

import {CoverArt} from '../../../services/data.model';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-coverart',
  templateUrl: './coverart-page.component.html',
  styleUrls: ['./coverart-page.component.scss']
})
export class CoverArtPageComponent {
  public coverArt: CoverArt;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {
      let coverArtId = this.route.snapshot.paramMap.get('coverArtId');
      this.http.get(
        environment.cmsUrl + environment.routes.listCoverArts + '/' + coverArtId
      ).subscribe((data: CoverArt) => {
          this.coverArt = data;
      });
  }
}
